// extracted by mini-css-extract-plugin
export default {"title":"FasilitasPelatihan_title__ACTAZ","fasilitasItems":"FasilitasPelatihan_fasilitasItems__ZJjRb","fasilitasItem":"FasilitasPelatihan_fasilitasItem__exS0u"};